import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Loading from "../helpers/loading_component.js";
import "../styles/payments.css";
import AddTransactionManualy from "./addTransactionManualy";
import ChangeTransactionIdentifier from "./change_transaction_identifier.js";
import AddPayment from "./add_payment.js";
import { secretKey } from "../.././data";
import AddClientConn from "./addClientConn.js";
import ClientPopUp from "./client_popup.js";

const MySwal = withReactContent(Swal2);

const PaymentsReport = (props) => {
  const [payment, setPayment] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [showAddManualy, setShowAddManualy] = useState(false);
  const [showChangeTransactionIdentifier, setShowChangeTransactionIdentifier] =
    useState(false);
  const [transactionValue, setTransactionValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [showAddPayments, setShowAddPayments] = useState(false);
  const [client, setClient] = useState([]);
  const [showAddClientConn, setShowAddClientConn] = useState(false);
  const [showClientReport, setShowClientReport] = useState(false);
  const [clientsReportValue, setClientsReportValue] = useState(false);
  const [clients, setClients] = useState([]);

  const showClientPopUp = (e) => {
    setShowClientReport(true);
    setClientsReportValue(payment.clientId);
  };

  const closeClientPopUp = (e) => {
    setShowClientReport(false);
    setClientsReportValue("");
  };

  const handleShowChangeTransactionIdentifier = (e) => {
    setShowChangeTransactionIdentifier(!showChangeTransactionIdentifier);
    setShowAddManualy(false);
    getData();
  };

  const handleShowAddPayment = (e) => {
    setShowAddPayments(!showAddPayments);
    getData();
  };

  const handleRowClick = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setTransactionValue(value);
    handleShowChangeTransactionIdentifier();
  };

  const acceptArchPayment = async (e) => {
    MySwal.fire({
      title: "Czy na pewno chcesz zarchiwizować rozliczenie?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        archivizePayment();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteTransactionAcc = async (e) => {
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć transakcję?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        deleteTransaction(e.target.value);
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteTransaction = async (id) => {
    var toEditData = transactions.filter((el) => +el.tr_id === +id)[0];

    var body = {
      date: toEditData.date,
      client: toEditData.client,
      title: toEditData.title,
      bank_acc: toEditData.bank_acc,
      tr_id: toEditData.tr_id,
      bank: toEditData.bank,
      bill: toEditData.bill,
      assign_date: toEditData.assign_date,
      checked: toEditData.checked,
      reason: "",
      note: toEditData.note,
      payId: "",
    };

    await fetch(
      "https://apidevkppp.ftpeople.pl/insertTransactionsNotAssigned",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      }
    )
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    var body = {
      tr_id: toEditData.tr_id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteTransactionAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        MySwal.fire({
          icon: "success",
          title: "Wycofano",
          text: "transakcję",
        }).then((result) => {
          getData();
        });
        return;
        await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            checkPayments(data);
          })
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const deleteTransactions = async (id) => {
    var toEditDataArr = transactions.filter(
      (el) => el.payId === payment.identifier
    );

    toEditDataArr.map(async (toEditData) => {
      var body = {
        date: toEditData.date,
        client: toEditData.client,
        title: toEditData.title,
        bank_acc: toEditData.bank_acc,
        tr_id: toEditData.tr_id,
        bank: toEditData.bank,
        bill: toEditData.bill,
        assign_date: toEditData.assign_date,
        checked: toEditData.checked,
        reason: "",
        note: toEditData.note,
        payId: "",
      };

      await fetch(
        "https://apidevkppp.ftpeople.pl/insertTransactionsNotAssigned",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        }
      )
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      var body = {
        tr_id: toEditData.tr_id,
      };

      await fetch("https://apidevkppp.ftpeople.pl/deleteTransactionAssigned", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then(async (data) => {})
        .catch((error) => {});
    });

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "płatność",
    }).then((result) => {
      props.close();
    });
  };

  const checkExpectedTransactionsCount = (
    dateOfStartPayment,
    installmentCount
  ) => {
    var now = new Date();
    var startDate = new Date(dateOfStartPayment);
    var months = (now.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += now.getMonth();
    return months <= 0
      ? 0
      : months > installmentCount
      ? installmentCount
      : months;
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const checkPayments = async (transactions) => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data.map(async (el) => {
          var transactionsForPayment = transactions.filter(
            (tr) => tr.payId === el.identifier
          );
          transactionsForPayment.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          });
          var pay_sum = 0;
          for (var i = 0; i < transactionsForPayment.length; i += 1) {
            pay_sum =
              parseFloat(transactionsForPayment[i].bill.replaceAll(",", ".")) +
              pay_sum;
          }

          var archive =
            parseInt(el.to_settlement) === parseInt(pay_sum) ? "TAK" : "NIE";
          var bankAcc = el.bank_acc;
          if (transactionsForPayment.length > 0) {
            if (
              !transactionsForPayment[0].title.includes("Wpłata w UP") &&
              !transactionsForPayment[0].client.includes("CINKCIARZ")
            ) {
              bankAcc = transactionsForPayment[0].bank_acc;
            }
          }

          var body2 = {
            identifier: el.identifier,
            pay_sum: pay_sum,
            bank_acc: bankAcc,
            pay_count: transactionsForPayment.length,
            pay_expected_count: checkExpectedTransactionsCount(
              el.first_payment_date,
              el.installment
            ),
            last_pay_date:
              transactionsForPayment.length > 0
                ? transactionsForPayment[0].date
                : "",
            is_overdated:
              checkExpectedTransactionsCount(
                el.first_payment_date,
                el.installment
              ) > transactionsForPayment.length
                ? "TAK"
                : "NIE",
            to_archive:
              parseInt(el.to_settlement.toString().replace(",", ".")) ===
              parseInt(pay_sum.toString().replace(",", "."))
                ? "TAK"
                : "NIE",
            delay_time:
              archive === "TAK"
                ? 0
                : getDelayTime(
                    el.first_payment_date,
                    transactionsForPayment.length,
                    checkExpectedTransactionsCount(
                      el.first_payment_date,
                      el.installment
                    )
                  ),
          };

          await fetch("https://apidevkppp.ftpeople.pl/editPaymentCheck", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});
        });
      })
      .catch((error) => {});
    MySwal.fire({
      icon: "success",
      title: "Wycofano",
      text: "transakcję",
    }).then((result) => {
      getData();
    });
  };

  const handleShowAddTransactionManualy = (e) => {
    setShowAddManualy(!showAddManualy);
    setShowChangeTransactionIdentifier(false);
    if (!showAddManualy === false) {
      getData();
    }
  };

  const days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
  };

  const getDelayTime = (dateOfStartPayment, pay_sum, expected_pay_count) => {
    var startDate = new Date(dateOfStartPayment);
    var now = new Date();
    var lastPaymentDateForDelay = new Date(
      startDate.setMonth(startDate.getMonth() + pay_sum)
    );
    var delay_days = days(now, lastPaymentDateForDelay);
    return delay_days < 0 ? 0 : delay_days;
  };

  const archivizePayment = async () => {
    setLoading(true);
    var toEditData = payment;
    var body = {
      name: toEditData.name,
      identifier: toEditData.identifier,
      email: toEditData.email,
      phone: toEditData.phone,
      first_payment_date: toEditData.first_payment_date,
      company: toEditData.company,
      type: toEditData.type,
      to_settlement: toEditData.to_settlement,
      installment: toEditData.installment,
      pay_sum: toEditData.pay_sum,
      pay_count: toEditData.pay_count,
      pay_expected_count: toEditData.pay_expected_count,
      last_pay_date: toEditData.last_pay_date,
      is_overdated: toEditData.is_overdated,
      to_archive: toEditData.to_archive,
      archive_date: new Date(),
      clientId: toEditData.clientId,
      bank_acc: toEditData.bank_acc,
      delay_time: toEditData.delay_time,
      id: payment.identifier,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertPaymentArchive", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    //deletePayment2(payment.id);

    MySwal.fire({
      icon: "success",
      title: "Zarchiwizowano",
      text: "rozliczenie",
    }).then((result) => {
      props.close();
    });
  };

  const deletePaymentAcc = async (e) => {
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć płatność?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        deletePayment(props.id);
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deletePayment2 = async (id) => {
    var body = {
      id: payment.id,
      identifier: payment.identifier,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deletePayment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        return;
      })
      .catch((error) => {});
  };

  const deletePayment = async (id) => {
    var body = {
      id: payment.id,
      identifier: payment.identifier,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deletePayment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        deleteTransactions();
      })
      .catch((error) => {});
  };

  const fetchTransactionsForPaymentsData = async (identifier) => {
    var body = {
      identifier: identifier,
    };

    await fetch(
      "https://apidevkppp.ftpeople.pl/getTransactionsAssignedPaymentId",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setTransactions(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchPaymentsData = async () => {
    var body = {
      id: props.id,
    };

    fetch("https://apidevkppp.ftpeople.pl/getPaymentsId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setPayment(data[0]);

        if (data[0].clientId !== "" || data[0].clientId !== undefined) {
          var body2 = {
            id: data[0].clientId,
          };

          await fetch("https://apidevkppp.ftpeople.pl/getClientsId", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then((data3) => {
              setClient(data3[0]);
            })
            .catch((error) => {});
        }
        fetchTransactionsForPaymentsData(data[0].identifier);
      })
      .catch((error) => {});
  };

  const fetchPaymentsArchiveData = async () => {
    var body = {
      id: props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getPaymentsId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setPayment(data[0]);
        if (data[0].clientId !== "" || data[0].clientId !== undefined) {
          var body2 = {
            id: data[0].clientId,
          };

          await fetch("https://apidevkppp.ftpeople.pl/getClientsId", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then((data3) => {
              setClient(data3[0]);
            })
            .catch((error) => {});
        }
        await fetchTransactionsForPaymentsData(data[0].identifier);
      })
      .catch((error) => {});
  };

  const getData = async () => {
    setShowChangeTransactionIdentifier(false);
    setShowAddManualy(false);
    setLoading(true);
    if (props.place === "arch") {
      await fetchPaymentsArchiveData();
    } else {
      await fetchPaymentsData();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const transactionsData = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th>Data transakcji</th>
          <th>Imię i nazwisko</th>
          <th>Tytuł przelewu</th>
          <th>Numer konta</th>
          <th>Bank</th>
          <th>ID</th>
          <th>Kwota</th>
          <th>ID rozliczenia</th>
          <th>Akcja</th>
        </tr>
        {transactions.map((el) => (
          <>
            <tr value={el.tr_id} onClick={handleRowClick}>
              <td>{el.date}</td>
              <td>{el.client}</td>
              <td>{el.title}</td>
              <td>{el.bank_acc}</td>
              <td>{el.bank}</td>
              <td>{el.tr_id}</td>
              <td>{el.bill}</td>
              <td>{el.payId}</td>
              <td>
                <button
                  id="deleteButtonTr"
                  className="paymentMenuButton"
                  value={el.tr_id}
                  onClick={deleteTransactionAcc}
                >
                  Usuń
                </button>
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const transactionsDataMobile = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th style={{ fontSize: "3vw" }}>Data transakcji</th>
          <th style={{ fontSize: "3vw" }}>ID rozliczenia</th>
        </tr>
        {transactions.map((el) => (
          <>
            <tr value={el.tr_id} onClick={handleRowClick}>
              <td>{el.date}</td>
              <td>{el.payId}</td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const showAddCLientP = () => {
    setShowAddClientConn(true);
  };

  const closeAddCLient = () => {
    setShowAddClientConn(false);
    getData();
  };

  const deleteConn = () => {
    MySwal.fire({
      title: "Czy na pewno chcesz powiązanie?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteConnAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteConnAccept = async () => {
    var body = {
      id: payment.id,
    };

    var url = "https://apidevkppp.ftpeople.pl/deleteClientPayment";
    var url2 = "https://apidevkppp.ftpeople.pl/deleteClientPayment2";

    await fetch(props.place === "arch" ? url2 : url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Usunięto", "powiązanie", "success").then((result) => {
      getData();
    });
  };

  const desktopReport = (
    <>
      <>
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="closeButtonBoxNotePopUp">
          <div className="tr_close">
            {payment.to_archive === "TAK" && props.userRole === "admin" ? (
              <button
                style={{ width: "15vw" }}
                className="paymentMenuButton"
                onClick={acceptArchPayment}
              >
                Archiwizuj
              </button>
            ) : (
              ""
            )}
            {props.userRole === "admin" ? (
              <button
                style={{ width: "15vw" }}
                className="paymentMenuButton"
                onClick={deletePaymentAcc}
              >
                Usuń
              </button>
            ) : (
              ""
            )}
            <button
              style={{ width: "15vw" }}
              className="paymentMenuButton"
              onClick={handleShowAddTransactionManualy}
            >
              Dodaj ręcznie transakcję
            </button>
            <button
              style={{ width: "15vw" }}
              className="paymentMenuButton"
              onClick={handleShowAddPayment}
            >
              Edytuj
            </button>
          </div>
        </div>
        <div style={{ display: "block" }} className="editButtonBox">
          {payment.clientId !== "" && payment.clientId !== undefined ? (
            <>
              <div style={{ marginBottom: "15px" }}>
                <span style={{ color: "black" }} className="highlight_green">
                  SPRAWA KLIENTA: {client.petitioner}
                </span>
              </div>
              <div style={{ display: "flex", gap: "20px" }}>
                <button
                  style={{ fontSize: "0.7vw" }}
                  className="paymentMenuButton"
                  onClick={showClientPopUp}
                >
                  ZOBACZ
                </button>
                <button
                  style={{ fontSize: "0.7vw" }}
                  className="paymentMenuButton"
                  onClick={deleteConn}
                >
                  USUŃ POWIĄZANIE
                </button>
              </div>
            </>
          ) : (
            <>
              <div style={{ marginBottom: "15px" }}>
                <span style={{ color: "black" }} className="highlight_green">
                  ROZPRAWA NIEPOWIĄZANA ZE SPRAWĄ
                </span>
              </div>
              <button
                style={{ fontSize: "0.7vw" }}
                className="paymentMenuButton"
                onClick={showAddCLientP}
              >
                DODAJ POWIĄZANIE
              </button>
            </>
          )}
        </div>
        <div className="contentBoxPayments">
          <div className="reportTitleP">Informacje o rozliczeniu:</div>
          <div className="infoBoxPB">
            <div className="infoBoxP">
              <div className="infoBoxP_col">
                Imię i nazwisko klienta:{" "}
                <span className="borderPR">{payment.name}</span>
              </div>
              <div className="infoBoxP_col">
                Identyfikator klienta:{" "}
                <span className="borderPR">{payment.identifier}</span>
              </div>
            </div>
            <div className="infoBoxP">
              <div className="infoBoxP_col">
                Adres e-mail: <span className="borderPR">{payment.email}</span>
              </div>
              <div className="infoBoxP_col">
                Numer telefonu:{" "}
                <span className="borderPR">{payment.phone}</span>
              </div>
            </div>
            <div className="infoBoxP">
              <div className="infoBoxP_col">
                Rodzaj: <span className="borderPR">{payment.type}</span>
              </div>
              <div className="infoBoxP_col">
                Data pierwszej płatności:{" "}
                <span className="borderPR">{payment.first_payment_date}</span>
              </div>
            </div>
            <div className="infoBoxP">
              <div className="infoBoxP_col">
                Kwota do rozliczenia:{" "}
                <span className="borderPR">{payment.to_settlement}</span>
              </div>
              <div className="infoBoxP_col">
                Kwota wpłacona:{" "}
                <span className="borderPR">{payment.pay_sum}</span>
              </div>
            </div>
            <div className="infoBoxP">
              <div className="infoBoxP_col">
                Ilość rat wpłaconych:{" "}
                <span className="borderPR">{payment.pay_count}</span>
              </div>
              <div className="infoBoxP_col">
                Ilość rat oczekiwanych:{" "}
                <span className="borderPR">{payment.pay_expected_count}</span>
              </div>
            </div>
            <div className="infoBoxP">
              <div className="infoBoxP_col">
                Ilość rat do zapłaty:{" "}
                <span className="borderPR">{payment.installment}</span>
              </div>
              <div className="infoBoxP_col"></div>
            </div>
            <div className="infoBoxP">
              <div className="infoBoxP_col">
                Opóźnienie?:{" "}
                <span className="borderPR">{payment.is_overdated}</span>
              </div>
              {false ? (
                <>
                  <div className="infoBoxP_col">
                    Do archiwizacji?:{" "}
                    <span className="borderPR">{payment.to_archive}</span>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="transactionsReport">
            <div className="reportTitleP">Transakcje:</div>

            {transactionsData}
          </div>
        </div>
      </>
    </>
  );

  const mobileReport = (
    <>
      <>
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="closeButtonBoxNotePopUp">
          <div className="tr_close" style={{ flexWrap: "wrap" }}>
            {(payment ? payment.to_archive === "TAK" : false) &&
            props.userRole === "admin" &&
            !payment.archive_date ? (
              <button
                style={{ width: "80vw" }}
                className="paymentMenuButton"
                onClick={acceptArchPayment}
              >
                Archiwizuj
              </button>
            ) : (
              ""
            )}
            {props.userRole === "admin" ? (
              <button
                style={{ width: "80vw" }}
                className="paymentMenuButton"
                onClick={deletePaymentAcc}
              >
                Usuń
              </button>
            ) : (
              ""
            )}
            <button
              style={{ width: "80vw" }}
              className="paymentMenuButton"
              onClick={handleShowAddTransactionManualy}
            >
              Dodaj ręcznie transakcję
            </button>
            <button
              style={{ width: "80vw" }}
              className="paymentMenuButton"
              onClick={handleShowAddPayment}
            >
              Edytuj
            </button>
          </div>
        </div>
        <div style={{ display: "block" }} className="editButtonBox">
          {payment.clientId !== "" && payment.clientId !== undefined ? (
            <>
              <div style={{ marginBottom: "15px" }}>
                <span style={{ color: "black" }} className="highlight_green">
                  SPRAWA KLIENTA: {client.petitioner}
                </span>
              </div>
              <div style={{ display: "flex", gap: "20px" }}>
                <button
                  style={{ fontSize: "2vw" }}
                  className="paymentMenuButton"
                  onClick={showClientPopUp}
                >
                  ZOBACZ
                </button>
                <button
                  style={{ fontSize: "2vw" }}
                  className="paymentMenuButton"
                  onClick={deleteConn}
                >
                  USUŃ POWIĄZANIE
                </button>
              </div>
            </>
          ) : (
            <>
              <div style={{ marginBottom: "15px" }}>
                <span style={{ color: "black" }} className="highlight_green">
                  ROZPRAWA NIEPOWIĄZANA ZE SPRAWĄ
                </span>
              </div>
              <button
                style={{ fontSize: "0.7vw" }}
                className="paymentMenuButton"
                onClick={showAddCLientP}
              >
                DODAJ POWIĄZANIE
              </button>
            </>
          )}
        </div>
        <div className="contentBoxPayments">
          <div className="reportTitleP" style={{ fontSize: "4vw" }}>
            Informacje o rozliczeniu:
          </div>
          <div className="infoBoxPB" style={{ margin: "5px 10px" }}>
            <div className="infoBoxP" style={{ flexWrap: "wrap" }}>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Imię i nazwisko klienta:{" "}
                <span className="borderPR">{payment.name}</span>
              </div>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Identyfikator klienta:{" "}
                <span className="borderPR">{payment.identifier}</span>
              </div>
            </div>
            <div className="infoBoxP" style={{ flexWrap: "wrap" }}>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Adres e-mail: <span className="borderPR">{payment.email}</span>
              </div>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Numer telefonu:{" "}
                <span className="borderPR">{payment.phone}</span>
              </div>
            </div>
            <div className="infoBoxP" style={{ flexWrap: "wrap" }}>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Rodzaj: <span className="borderPR">{payment.type}</span>
              </div>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Data pierwszej płatności:{" "}
                <span className="borderPR">{payment.first_payment_date}</span>
              </div>
            </div>
            <div className="infoBoxP" style={{ flexWrap: "wrap" }}>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Kwota do rozliczenia:{" "}
                <span className="borderPR">{payment.to_settlement}</span>
              </div>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Kwota wpłacona:{" "}
                <span className="borderPR">{payment.pay_sum}</span>
              </div>
            </div>
            <div className="infoBoxP" style={{ flexWrap: "wrap" }}>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Ilość rat wpłaconych:{" "}
                <span className="borderPR">{payment.pay_count}</span>
              </div>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Ilość rat oczekiwanych:{" "}
                <span className="borderPR">{payment.pay_expected_count}</span>
              </div>
            </div>
            <div className="infoBoxP" style={{ flexWrap: "wrap" }}>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Ilość rat do zapłaty:{" "}
                <span className="borderPR">{payment.installment}</span>
              </div>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              ></div>
            </div>
            <div className="infoBoxP" style={{ flexWrap: "wrap" }}>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Opóźnienie?:{" "}
                <span className="borderPR">{payment.is_overdated}</span>
              </div>
              <div
                className="infoBoxP_col"
                style={{ width: "100%", marginTop: "1vh" }}
              >
                Do archiwizacji?:{" "}
                <span className="borderPR">{payment.to_archive}</span>
              </div>
            </div>
          </div>
          <div className="transactionsReport">
            <div
              className="reportTitleP"
              style={{ fontSize: "4vw", marginTop: "3vh" }}
            >
              Transakcje:
            </div>

            {transactionsDataMobile}
          </div>
        </div>
      </>
    </>
  );

  return (
    <>
      <div id="reportP" className="mainContainerTransactions">
        {loading ? (
          <Loading />
        ) : (
          <>
            {showChangeTransactionIdentifier ? (
              <ChangeTransactionIdentifier
                close={handleShowChangeTransactionIdentifier}
                paymentsData={props.paymentsData}
                paymentsSheetData={props.paymentsSheetData}
                transactionsSheetData={props.transactionsSheetData}
                transactionsData={props.transactionsData}
                id={transactionValue}
                refreshData={props.refreshData}
                type={props.type}
                paymentId={props.id}
                mode={"report"}
              />
            ) : (
              ""
            )}
            {showClientReport ? (
              <ClientPopUp
                close={closeClientPopUp}
                paymentsData={props.paymentsData}
                paymentsSheetData={props.paymentsSheetData}
                transactionsSheetData={props.transactionsSheetData}
                transactionsASheetData={props.transactionsNaSheetData}
                transactionsData={props.transactionsData}
                paymentsArchiveSheetData={props.paymentsArchiveSheetData}
                id={clientsReportValue}
                team={props.team}
                refreshData={props.refreshData}
                user={props.user}
                clientsData={client}
                clientsSheetData={props.clientsSheetData}
                userRole={props.userRole}
                userMail={props.upData.mail}
                userPhone={props.upData.phone}
                tasksData={props.tasksData}
                hearingsData={props.hearingsData}
                hearingsSheetData={props.hearingsSheetData}
                tasksSheetData={props.tasksSheetData}
                lawyersData={props.lawyersData}
                courtsData={props.courtsData}
                banksData={props.banksData}
                users={props.users}
                resultsData={props.resultsData}
                tasksTypesData={props.tasksTypesData}
                checkPermissions={props.checkPermissions}
                hearingsTeam2Data={props.hearingsTeam2Data}
                hearingsTeam2SheetData={props.hearingsTeam2SheetData}
                tasksTeam2Data={props.tasksTeam2Data}
                tasksTeam2SheetData={props.tasksTeam2SheetData}
                archTasksTeam2={props.archTasksTeam2}
                archDateTeam2={props.archDateTeam2}
                archDate={props.archDate}
                clientsSygnSheetData={props.clientsSygnSheetData}
                clientsContactData={props.clientsContactData}
                clientsContactSheetData={props.clientsContactSheetData}
                logClientAction={props.logClientAction}
                clientsLogsData={props.clientsLogsData}
                clientsQuestData={props.clientsQuestData}
                clientsQuestSheetData={props.clientsQuestSheetData}
                tabIndex={0}
                uData={props.upData}
                clientsFullData={clients}
                filesData={props.filesData}
              />
            ) : (
              ""
            )}
            {showAddClientConn ? (
              <AddClientConn
                close={closeAddCLient}
                id={payment.id}
                team={props.team}
                place={props.place === "arch" ? "paymentA" : "payment"}
                mail={payment.email}
                phone={payment.phone}
                user={props.upData}
              />
            ) : (
              ""
            )}
            {showAddManualy ? (
              <AddTransactionManualy
                refreshData={props.refreshData}
                paymentsSheetData={props.paymentsSheetData}
                transactionsSheetData={props.transactionsSheetData}
                user={props.place === "client" ? props.user.name : props.user}
                id={props.id}
                client={client}
                close={handleShowAddTransactionManualy}
              />
            ) : (
              ""
            )}
            {showAddPayments ? (
              <>
                <AddPayment
                  close={handleShowAddPayment}
                  paymentsSheetData={props.paymentsSheetData}
                  paymentsData={props.paymentsData}
                  refreshData={props.refreshData}
                  mode="edit"
                  payment={payment}
                  transactionsSheetData={props.transactionsSheetData}
                  client={client}
                />
              </>
            ) : (
              ""
            )}
            {showClientReport ? (
              ""
            ) : (
              <>
                <div className="desktopFilters">{desktopReport}</div>
                <div className="mobileFilters">{mobileReport}</div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default PaymentsReport;
